export default "__VITE_PUBLIC_ASSET__7cafa5d5__"